import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-image-generate" }
const _hoisted_2 = { class: "page-header" }

import { useRouter } from 'vue-router';
  import { ArrowLeftOutlined } from '@ant-design/icons-vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MenuImageGenerateView',
  setup(__props) {

  const router = useRouter();

  const goBack = () => {
    router.back();
  };

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { bordered: false }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "text",
            class: "back-button",
            onClick: goBack
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(ArrowLeftOutlined))
            ]),
            _: 1
          }),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "page-title" }, "菜单图生成", -1))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})